module.exports = new __parcel__URL__("pay-wall-person.a1a60f18.png").toString();